/* ================================================================
   MURDAWEIGHT SHOPIFY THEME — theme.js
   Vanilla JS: mobile menu, cart AJAX, swipe, quick view, accordion
   ================================================================ */

'use strict';

var MW = window.MW || {};

/* ── Utility: format money ─────────────────────────────────── */
MW.formatMoney = function(cents) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  var value = parseInt(cents, 10);
  var dollars = (value / 100).toFixed(2);
  return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/* ── Announcement Bar ──────────────────────────────────────── */
MW.announcementBar = {
  bar: null,
  header: null,
  init: function() {
    this.bar = document.querySelector('.announcement-bar');
    this.header = document.querySelector('.header');
    if (!this.bar || !this.header) return;
    window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    this.onScroll();
  },
  onScroll: function() {
    var scrolled = window.scrollY > 50;
    if (scrolled) {
      this.bar.classList.add('announcement-bar--hidden');
      this.header.classList.remove('header--announcement');
      this.header.classList.add('header--no-announcement');
      this.header.classList.add('header--scrolled');
      this.header.classList.remove('header--transparent');
    } else {
      this.bar.classList.remove('announcement-bar--hidden');
      this.header.classList.add('header--announcement');
      this.header.classList.remove('header--no-announcement');
      this.header.classList.remove('header--scrolled');
      this.header.classList.add('header--transparent');
    }
  }
};

/* ── Mobile Menu ───────────────────────────────────────────── */
MW.mobileMenu = {
  menu: null,
  openBtn: null,
  closeBtn: null,
  isOpen: false,
  init: function() {
    this.menu = document.getElementById('mobile-menu');
    this.openBtn = document.querySelector('[data-mobile-menu-open]');
    this.closeBtn = document.querySelector('[data-mobile-menu-close]');
    if (!this.menu) return;
    if (this.openBtn) this.openBtn.addEventListener('click', this.open.bind(this));
    if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this));
    // Accordion
    var accordionTriggers = this.menu.querySelectorAll('[data-accordion]');
    accordionTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var target = document.getElementById(trigger.dataset.accordion);
        if (!target) return;
        var open = target.classList.contains('is-open');
        trigger.classList.toggle('is-open', !open);
        target.classList.toggle('is-open', !open);
      });
    });
    // Close on link click
    var links = this.menu.querySelectorAll('a');
    var self = this;
    links.forEach(function(link) { link.addEventListener('click', function() { self.close(); }); });
  },
  open: function() {
    this.menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.isOpen = true;
  },
  close: function() {
    this.menu.classList.remove('is-open');
    document.body.style.overflow = '';
    this.isOpen = false;
  }
};

/* ── Desktop Dropdown ──────────────────────────────────────── */
MW.dropdown = {
  init: function() {
    var triggers = document.querySelectorAll('[data-dropdown-trigger]');
    triggers.forEach(function(trigger) {
      var menuId = trigger.dataset.dropdownTrigger;
      var menu = document.getElementById(menuId);
      if (!menu) return;
      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = menu.classList.contains('is-open');
        // Close all
        document.querySelectorAll('.nav-dropdown-menu.is-open').forEach(function(m) { m.classList.remove('is-open'); });
        document.querySelectorAll('.nav-dropdown-trigger.is-open').forEach(function(t) { t.classList.remove('is-open'); });
        if (!isOpen) {
          menu.classList.add('is-open');
          trigger.classList.add('is-open');
        }
      });
    });
    document.addEventListener('click', function() {
      document.querySelectorAll('.nav-dropdown-menu.is-open').forEach(function(m) { m.classList.remove('is-open'); });
      document.querySelectorAll('.nav-dropdown-trigger.is-open').forEach(function(t) { t.classList.remove('is-open'); });
    });
  }
};

/* ── Accordion ─────────────────────────────────────────────── */
MW.accordion = {
  init: function(container) {
    var triggers = (container || document).querySelectorAll('[data-accordion-trigger]');
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var bodyId = trigger.dataset.accordionTrigger;
        var body = document.getElementById(bodyId);
        if (!body) return;
        var open = body.classList.contains('is-open');
        trigger.classList.toggle('is-open', !open);
        body.classList.toggle('is-open', !open);
      });
    });
  }
};

/* ── Cart AJAX ─────────────────────────────────────────────── */
MW.cart = {
  state: { items: [], total_price: 0 },
  init: function() {
    this.fetchCart();
    document.addEventListener('cart:updated', this.renderDrawer.bind(this));
  },
  fetchCart: function() {
    var self = this;
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        self.state = data;
        self.updateBadge();
        self.renderDrawer();
      });
  },
  addItem: function(variantId, quantity, opts) {
    var self = this;
    opts = opts || {};
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity, properties: opts.properties || {} })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      return self.fetchCartAndReturn();
    });
  },
  fetchCartAndReturn: function() {
    var self = this;
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        self.state = data;
        self.updateBadge();
        self.renderDrawer();
        return data;
      });
  },
  updateItem: function(key, quantity) {
    var self = this;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      self.state = data;
      self.updateBadge();
      self.renderDrawer();
      return data;
    });
  },
  removeItem: function(key) { return this.updateItem(key, 0); },
  updateBadge: function() {
    var badge = document.getElementById('cart-badge');
    if (!badge) return;
    var count = this.state.item_count || 0;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  },
  openDrawer: function() {
    document.getElementById('cart-drawer').classList.add('is-open');
    document.getElementById('cart-drawer-overlay').classList.add('is-open');
    document.body.style.overflow = 'hidden';
  },
  closeDrawer: function() {
    document.getElementById('cart-drawer').classList.remove('is-open');
    document.getElementById('cart-drawer-overlay').classList.remove('is-open');
    document.body.style.overflow = '';
  },
  renderDrawer: function() {
    var items = this.state.items || [];
    var container = document.getElementById('cart-drawer-items');
    var footer = document.getElementById('cart-drawer-footer');
    var total = document.getElementById('cart-drawer-total');
    if (!container) return;
    if (items.length === 0) {
      container.innerHTML = '<div class="cart-drawer__empty"><div class="cart-drawer__empty-icon"><svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div><p>Your cart is empty</p><a href="/collections/all" class="btn btn--outline btn--md" onclick="MW.cart.closeDrawer()" style="margin-top:1rem">CONTINUE SHOPPING</a></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    var html = items.map(function(item) {
      return '<div class="cart-item"><div class="cart-item__img"><img src="' + item.image + '" alt="' + item.title + '"></div><div class="cart-item__info"><div class="cart-item__top"><div><p class="cart-item__name">' + item.product_title + '</p><p class="cart-item__variant">' + item.variant_title + '</p></div><button class="cart-item__remove" onclick="MW.cart.removeItem(\'' + item.key + '\')" aria-label="Remove"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div><div class="cart-item__bottom"><div class="cart-item__qty"><button class="cart-item__qty-btn" onclick="MW.cart.updateItem(\'' + item.key + '\',' + (item.quantity - 1) + ')"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg></button><span class="cart-item__qty-num">' + item.quantity + '</span><button class="cart-item__qty-btn" onclick="MW.cart.updateItem(\'' + item.key + '\',' + (item.quantity + 1) + ')"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button></div><span class="cart-item__price">' + MW.formatMoney(item.final_line_price) + '</span></div></div></div>';
    }).join('');
    container.innerHTML = html;
    if (footer) footer.style.display = 'block';
    if (total) total.textContent = MW.formatMoney(this.state.total_price);
  }
};

/* ── Quick View ────────────────────────────────────────────── */
MW.quickView = {
  current: null,
  init: function() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      e.preventDefault();
      MW.quickView.open(btn.dataset.quickView, btn.dataset.productUrl);
    });
  },
  open: function(productHandle, productUrl) {
    var self = this;
    var modal = document.getElementById('quick-view-modal');
    var overlay = document.getElementById('quick-view-overlay');
    var content = document.getElementById('quick-view-content');
    if (!modal || !content) return;
    content.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:300px;color:rgba(255,255,255,0.4);font-size:0.875rem;letter-spacing:0.1em;text-transform:uppercase;">Loading...</div>';
    modal.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var qvUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/') + 'products/' + encodeURIComponent(productHandle) + '.js';

    fetch(qvUrl, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(product) {
        self.current = product;
        self.render(product, productUrl, content);
        MW.accordion.init(content);
      })
      .catch(function(err) {
        console.error('[MW QuickView] Failed to load product "' + productHandle + '":', err);
        content.innerHTML = '<div style="padding:2rem;color:rgba(255,255,255,0.5)">Could not load product. <a href="' + (productUrl || '/products/' + productHandle) + '" style="color:var(--primary)">View product page \u2192</a></div>';
      });
  },
  close: function() {
    var modal = document.getElementById('quick-view-modal');
    var overlay = document.getElementById('quick-view-overlay');
    if (modal) modal.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    this.current = null;
  },
  render: function(product, productUrl, container) {
    var variant = product.variants[0];
    var price = MW.formatMoney(variant.price);
    var img = product.featured_image || (product.images && product.images[0]) || '';
    var badges = product.tags.filter(function(t) { return t === 'BESTSELLER' || t === 'NEW'; });
    var badgeHtml = badges.map(function(b) { return '<span class="quick-view-modal__badge">' + b + '</span>'; }).join('');

    // Shopify product JSON: product.options = ["Color","Size"] (strings, not objects)
    // Derive unique values per option from variants (option1, option2, option3)
    function optionValues(position) {
      var seen = {}, vals = [];
      product.variants.forEach(function(v) {
        var val = v['option' + position];
        if (val && !seen[val]) { seen[val] = true; vals.push(val); }
      });
      return vals;
    }

    var colorsHtml = '', sizesHtml = '';
    product.options.forEach(function(optName, idx) {
      var pos = idx + 1;
      var vals = optionValues(pos);
      var nameLower = optName.toLowerCase();
      if (nameLower === 'color') {
        colorsHtml = '<div><p class="selector-label">Color: <span id="qv-color-name">' + (variant['option' + pos] || vals[0]) + '</span></p><div class="color-swatches" id="qv-colors">' +
          vals.map(function(v, i) {
            return '<button class="size-btn' + (i === 0 ? ' is-active' : '') + '" data-qv-color="' + v + '" data-qv-opt-pos="' + pos + '" onclick="MW.quickView.selectColor(this)">' + v + '</button>';
          }).join('') + '</div></div>';
      } else if (nameLower === 'size') {
        sizesHtml = '<div><p class="selector-label">Size</p><div class="size-buttons" id="qv-sizes">' +
          vals.map(function(v, i) {
            return '<button class="size-btn' + (i === 0 ? ' is-active' : '') + '" data-qv-size="' + v + '" data-qv-opt-pos="' + pos + '" onclick="MW.quickView.selectSize(this)">' + v + '</button>';
          }).join('') + '</div></div>';
      }
    });

    container.innerHTML = '<div class="quick-view-modal__image"><img src="' + img + '" alt="' + product.title + '">' + badgeHtml + '</div><div class="quick-view-modal__details"><div><h2 class="quick-view-modal__name">' + product.title + '</h2><p class="quick-view-modal__price">' + price + '</p></div><p class="quick-view-modal__desc">' + (product.description || '').replace(/<[^>]+>/g, '').substring(0, 200) + '</p>' + colorsHtml + sizesHtml + '<div><p class="selector-label">Quantity</p><div class="qty-control"><button class="qty-btn" onclick="MW.quickView.changeQty(-1)"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg></button><span class="qty-display" id="qv-qty">1</span><button class="qty-btn" onclick="MW.quickView.changeQty(1)"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button></div></div><div class="quick-view-modal__actions"><button id="qv-atc-btn" class="atc-btn" onclick="MW.quickView.addToCart()">ADD TO CART</button><a href="' + (productUrl || '/products/' + product.handle) + '" class="quick-view-modal__full-link" onclick="MW.quickView.close()">View Full Details <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></a></div></div>';
    this._qty = 1;
    this._variantId = variant.id;
  },
  _qty: 1,
  _variantId: null,
  changeQty: function(delta) {
    this._qty = Math.max(1, (this._qty || 1) + delta);
    var el = document.getElementById('qv-qty');
    if (el) el.textContent = this._qty;
  },
  _resolveVariant: function() {
    var product = this.current;
    if (!product) return;
    // Build a selected-value map keyed by option position (1,2,3)
    // from the active buttons — each button carries data-qv-opt-pos
    var selected = {};
    var colorBtn = document.querySelector('#qv-colors .size-btn.is-active');
    if (colorBtn) selected[colorBtn.dataset.qvOptPos] = colorBtn.dataset.qvColor;
    var sizeBtn = document.querySelector('#qv-sizes .size-btn.is-active');
    if (sizeBtn) selected[sizeBtn.dataset.qvOptPos] = sizeBtn.dataset.qvSize;

    var matched = product.variants.find(function(v) {
      return Object.keys(selected).every(function(pos) {
        return v['option' + pos] === selected[pos];
      });
    });
    if (matched) {
      this._variantId = matched.id;
      var priceEl = document.querySelector('.quick-view-modal__price');
      if (priceEl) priceEl.textContent = MW.formatMoney(matched.price);
      var atcBtn = document.getElementById('qv-atc-btn');
      if (atcBtn) {
        atcBtn.disabled = !matched.available;
        atcBtn.textContent = matched.available ? 'ADD TO CART' : 'SOLD OUT';
      }
    }
  },
  selectColor: function(btn) {
    var container = document.getElementById('qv-colors');
    if (container) container.querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    var nameEl = document.getElementById('qv-color-name');
    if (nameEl) nameEl.textContent = btn.dataset.qvColor;
    MW.quickView._resolveVariant();
  },
  selectSize: function(btn) {
    var container = document.getElementById('qv-sizes');
    if (container) container.querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    MW.quickView._resolveVariant();
  },
  addToCart: function() {
    var btn = document.getElementById('qv-atc-btn');
    var variantId = this._variantId;
    var qty = this._qty || 1;
    if (!variantId) return;
    if (btn) { btn.textContent = 'ADDING...'; btn.disabled = true; }
    MW.cart.addItem(variantId, qty).then(function() {
      if (btn) { btn.textContent = 'ADDED TO CART \u2713'; btn.classList.add('is-added'); }
      setTimeout(function() {
        MW.quickView.close();
        MW.cart.openDrawer();
      }, 800);
    });
  }
};

/* ── Product Gallery (Mobile Swipe) ─────────────────────────── */
MW.gallery = {
  init: function() {
    var galleries = document.querySelectorAll('[data-product-gallery]');
    galleries.forEach(function(gallery) {
      var images = JSON.parse(gallery.dataset.productGallery || '[]');
      if (!images.length) return;
      var mainImg = gallery.querySelector('[data-gallery-main]');
      var dots = gallery.querySelectorAll('[data-gallery-dot]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var current = 0;
      var touchStartX = null;

      function goTo(idx) {
        idx = ((idx % images.length) + images.length) % images.length;
        current = idx;
        if (mainImg) mainImg.src = images[idx];
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
      }

      if (mainImg) {
        mainImg.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
        mainImg.addEventListener('touchend', function(e) {
          if (touchStartX === null) return;
          var delta = e.changedTouches[0].clientX - touchStartX;
          touchStartX = null;
          if (Math.abs(delta) < 40) return;
          goTo(delta < 0 ? current + 1 : current - 1);
        });
      }

      dots.forEach(function(dot, i) { dot.addEventListener('click', function() { goTo(i); }); });
      thumbs.forEach(function(thumb, i) { thumb.addEventListener('click', function() { goTo(i); }); });
    });
  }
};

/* ── Product Detail ATC ────────────────────────────────────── */
MW.productDetail = {
  init: function() {
    var form = document.getElementById('product-form');
    if (!form) return;

    var atcBtn    = document.getElementById('atc-btn');
    var stickyBtn = document.getElementById('sticky-atc-btn');
    var mainImg   = document.getElementById('pdp-main-img');
    var qtyDisplay = document.querySelectorAll('[data-qty-display]');
    var qty = 1;

    var variantsData = [];
    try { variantsData = JSON.parse(form.dataset.variants || '[]'); } catch(e) {}

    /* ── Quantity ── */
    function updateQty() { qtyDisplay.forEach(function(el) { el.textContent = qty; }); }
    document.querySelectorAll('[data-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() { qty = Math.max(1, qty - 1); updateQty(); });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() { qty++; updateQty(); });
    });

    /* ── Variant matching ──
       Reads currently active color + size buttons and finds the matching variant.
       Updates form[name="id"] and returns the match (or null). */
    function matchVariant() {
      var activeColor = form.querySelector('[data-color-swatch].is-active');
      var activeSize  = form.querySelector('[data-size-btn].is-active');
      var colorVal    = activeColor ? activeColor.dataset.colorValue : null;
      var sizeVal     = activeSize  ? activeSize.dataset.sizeValue   : null;

      var colorInput = form.querySelector('[name="option-color"]');
      var sizeInput  = form.querySelector('[name="option-size"]');
      var colorKey   = colorInput ? colorInput.dataset.optionIndex : null;
      var sizeKey    = sizeInput  ? sizeInput.dataset.optionIndex  : null;

      var match = variantsData.find(function(v) {
        var colorOk = !colorKey || !colorVal || v[colorKey] === colorVal;
        var sizeOk  = !sizeKey  || !sizeVal  || v[sizeKey]  === sizeVal;
        return colorOk && sizeOk;
      });

      if (match) {
        form.querySelector('[name="id"]').value = match.id;
        /* Update price */
        var priceEl = document.querySelector('.pdp__price');
        if (priceEl) priceEl.textContent = MW.formatMoney(match.price);
        /* Update ATC disabled state */
        var available = match.available !== false;
        [atcBtn, stickyBtn].forEach(function(b) {
          if (!b) return;
          b.disabled = !available;
          if (!available) b.textContent = 'SOLD OUT';
          else b.textContent = b.dataset.originalText || 'ADD TO CART';
        });
      }
      return match || null;
    }

    /* ── Color name buttons ── */
    form.querySelectorAll('[data-color-swatch]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        form.querySelectorAll('[data-color-swatch]').forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        /* Update label */
        var nameEl = document.getElementById('selected-color-name');
        if (nameEl) nameEl.textContent = btn.dataset.colorName;

        /* Switch main image */
        var imgUrl = btn.dataset.colorImg;
        if (mainImg && imgUrl) {
          mainImg.src = imgUrl;
          /* Also mark matching thumbnail active */
          document.querySelectorAll('[data-pdp-thumb]').forEach(function(t) {
            t.classList.toggle('is-active', t.dataset.pdpThumb === imgUrl);
          });
        }

        /* Sync hidden input then match variant */
        var hiddenInput = form.querySelector('[name="option-color"]');
        if (hiddenInput) hiddenInput.value = btn.dataset.colorValue;
        matchVariant();
      });
    });

    /* ── Size buttons ── */
    form.querySelectorAll('[data-size-btn]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        form.querySelectorAll('[data-size-btn]').forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        /* Sync hidden input then match variant */
        var hiddenInput = form.querySelector('[name="option-size"]');
        if (hiddenInput) hiddenInput.value = btn.dataset.sizeValue;
        matchVariant();
      });
    });

    /* ── Add to Cart ── */
    function doATC(btn) {
      /* Re-match right before sending to guarantee correct variant */
      matchVariant();
      var variantId = form.querySelector('[name="id"]').value;
      var origText = btn.dataset.originalText || 'ADD TO CART';
      btn.textContent = btn.dataset.addingText || 'ADDING...';
      btn.disabled = true;
      MW.cart.addItem(variantId, qty).then(function() {
        btn.textContent = btn.dataset.addedText || 'ADDED ✓';
        btn.classList.add('is-added');
        setTimeout(function() {
          btn.textContent = origText;
          btn.classList.remove('is-added');
          btn.disabled = false;
          MW.cart.openDrawer();
        }, 900);
      }).catch(function() {
        btn.textContent = origText;
        btn.disabled = false;
      });
    }

    if (atcBtn) {
      atcBtn.dataset.originalText = atcBtn.textContent.trim();
      atcBtn.addEventListener('click', function() { doATC(atcBtn); });
    }
    if (stickyBtn) {
      stickyBtn.dataset.originalText = stickyBtn.textContent.trim();
      stickyBtn.addEventListener('click', function() { doATC(stickyBtn); });
    }

    /* Run once on load to sync initial state */
    matchVariant();
  }
};

/* ── Collection Filters ────────────────────────────────────── */
MW.collectionFilters = {
  init: function() {
    var mobileFilterBtn = document.getElementById('mobile-filter-btn');
    var mobileFilterDrawer = document.getElementById('mobile-filter-drawer');
    var filterClose = document.getElementById('filter-close');
    if (mobileFilterBtn && mobileFilterDrawer) {
      mobileFilterBtn.addEventListener('click', function() {
        mobileFilterDrawer.classList.toggle('is-open');
      });
    }
    if (filterClose && mobileFilterDrawer) {
      filterClose.addEventListener('click', function() {
        mobileFilterDrawer.classList.remove('is-open');
      });
    }
    // Apparel sub-accordion
    var apparelToggle = document.getElementById('apparel-toggle');
    var apparelSub = document.getElementById('apparel-sub');
    if (apparelToggle && apparelSub) {
      apparelToggle.addEventListener('click', function() {
        var open = apparelSub.classList.contains('is-open');
        apparelSub.classList.toggle('is-open', !open);
        apparelToggle.classList.toggle('is-open', !open);
      });
    }
  }
};

/* ── Newsletter form ───────────────────────────────────────── */
MW.newsletter = {
  init: function() {
    // Let Shopify handle form submission natively (action="/contact#contact_form").
    // Success state is controlled server-side via form.posted_successfully? Liquid.
    // No preventDefault — we just add a loading indicator on submit.
    var forms = document.querySelectorAll('[data-newsletter-form]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function() {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) {
          btn.disabled = true;
          btn.textContent = '...';
        }
      });
    });
  }
};

/* ── Contact Form ──────────────────────────────────────────── */
MW.contactForm = {
  init: function() {
    var form = document.getElementById('contact-form');
    if (!form) return;
    form.addEventListener('submit', function() {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'SENDING...'; }
    });
  }
};

/* ── Cart page inline qty ──────────────────────────────────── */
MW.cartPage = {
  init: function() {
    var form = document.getElementById('cart-form');
    if (!form) return;
    // Qty buttons on cart page
    function updatePageTotals() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(state) {
          var subtotalEl = document.querySelector('[data-cart-subtotal]');
          if (subtotalEl) subtotalEl.textContent = MW.formatMoney(state.total_price);
          state.items.forEach(function(item) {
            var lineEl = document.querySelector('[data-cart-line-price="' + item.key + '"]');
            if (lineEl) lineEl.textContent = MW.formatMoney(item.final_line_price);
          });
          if (state.item_count === 0) {
            var emptyMsg = document.querySelector('[data-cart-empty]');
            if (emptyMsg) emptyMsg.style.display = '';
            var cartContent = document.querySelector('[data-cart-content]');
            if (cartContent) cartContent.style.display = 'none';
          }
        });
    }

    form.querySelectorAll('[data-cart-qty-minus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.cartQtyMinus;
        var display = btn.nextElementSibling;
        var qty = parseInt(display.textContent, 10) - 1;
        if (qty < 1) qty = 0;
        display.textContent = qty;
        MW.cart.updateItem(key, qty).then(updatePageTotals);
        if (qty === 0) btn.closest('.cart-page__item').remove();
      });
    });
    form.querySelectorAll('[data-cart-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.cartQtyPlus;
        var display = btn.previousElementSibling;
        var qty = parseInt(display.textContent, 10) + 1;
        display.textContent = qty;
        MW.cart.updateItem(key, qty).then(updatePageTotals);
      });
    });
    form.querySelectorAll('[data-cart-remove]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        MW.cart.removeItem(btn.dataset.cartRemove).then(updatePageTotals);
        btn.closest('.cart-page__item').remove();
      });
    });
  }
};

/* ── Product Recommendations (AJAX) ────────────────────────── */
MW.productRecommendations = {
  init: function() {
    var section = document.getElementById('product-recommendations');
    if (!section) return;
    var url = section.dataset.recommendationsUrl;
    if (!url) return;
    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var inner = doc.getElementById('product-recommendations');
        if (inner) {
          // Replace only the grid, not the entire section to preserve title
          var newGrid = inner.querySelector('.related-products__grid');
          var currentGrid = section.querySelector('.related-products__grid');
          if (newGrid && currentGrid && newGrid.children.length > 0) {
            currentGrid.innerHTML = newGrid.innerHTML;
          }
        }
      })
      .catch(function() {
        // Silently fail — fallback content is already rendered
      });
  }
};

/* ── Size Guide Modal ──────────────────────────────────────── */
MW.sizeGuide = {
  init: function() {
    var modal   = document.getElementById('size-guide-modal');
    if (!modal) return;
    var trigger = document.querySelector('.pdp__size-guide');
    var close   = modal.querySelector('.sg-modal__close');
    var backdrop = modal.querySelector('.sg-modal__backdrop');

    function open() {
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (close) close.focus();
    }
    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (trigger) trigger.focus();
    }

    if (trigger) trigger.addEventListener('click', function(e) { e.preventDefault(); open(); });
    if (close)   close.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });

    // Tab switching
    modal.querySelectorAll('[data-sg-tab]').forEach(function(tab) {
      tab.addEventListener('click', function() {
        modal.querySelectorAll('[data-sg-tab]').forEach(function(t) { t.classList.remove('is-active'); });
        modal.querySelectorAll('[data-sg-panel]').forEach(function(p) { p.style.display = 'none'; });
        tab.classList.add('is-active');
        var panel = modal.querySelector('[data-sg-panel="' + tab.dataset.sgTab + '"]');
        if (panel) panel.style.display = 'block';
      });
    });
  }
};

/* ── Init ──────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  MW.announcementBar.init();
  MW.mobileMenu.init();
  MW.dropdown.init();
  MW.accordion.init();
  MW.cart.init();
  MW.quickView.init();
  MW.gallery.init();
  MW.productDetail.init();
  MW.productRecommendations.init();
  MW.collectionFilters.init();
  MW.newsletter.init();
  MW.contactForm.init();
  MW.cartPage.init();
  MW.sizeGuide.init();
});

/* ── Lazy image fade-in ─────────────────────────── */
(function() {
  if (!('IntersectionObserver' in window)) return;
  var imgs = document.querySelectorAll('img[loading="lazy"]');
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        var img = e.target;
        if (img.complete) {
          img.classList.add('is-loaded');
        } else {
          img.addEventListener('load', function() { img.classList.add('is-loaded'); }, { once: true });
        }
        io.unobserve(img);
      }
    });
  }, { rootMargin: '200px' });
  imgs.forEach(function(img) { io.observe(img); });
})();

window.MW = MW;
